export default __webpack_public_path__ + "static/media/lesson5.066f0e4f.svg";